StorageListController.$inject = ['StorageService'];
export default function StorageListController(StorageService) {
    var ctrl = this;

    ctrl.$onChanges = function(changes) {
        if (changes) {
            ctrl.database = changes.database.currentValue;
        }
    };


    ctrl.load = load;


    ctrl.$onInit = function() {
        load();
    };

    ////////

    function load() {
        var qs = {
            database: ctrl.database
        };
        StorageService.get(qs).$promise.then(function(response) {
            ctrl.content = response;
        });
    }
}
